
<template>
  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>会员列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row :gutter="10" style="min-height: 40px">
          <el-col :span="24" style="margin-bottom: 5px;display: flex" align="left" >
            <el-input v-model="keyValue" placeholder="请输入手机号/昵称" style="width: 200px"></el-input>
            <el-button type="primary" @click="getstart()">搜索</el-button>
            <el-checkbox v-model="checked" @change="getstart()" style="margin:7px">待绑定</el-checkbox>


            <el-button type="primary" @click="addddd()" style="position: absolute;right: 20px">添加会员</el-button>


          </el-col>
        </el-row>
        <!--表格-->
        <el-table
          border
          align="left"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="mobile"
            label="手机号">
          </el-table-column>
          <el-table-column
            label="会员类型"
            width="170">
            <template slot-scope="scope">
              {{scope.row.member_type=='vip12'?'12个月会员':scope.row.member_type=='vip9day'?'9天会员':''}}
              <!--              <el-button  v-if="scope.row.state=='2' || scope.row.state=='1'" @click="ProcessingMesge(scope.row.member_id)" size="small" type="text">取消会员绑定</el-button>-->
              <!--              <el-button   v-if="scope.row.state=='3'&& scope.row.refund_state=='1' "size="small" type="text" style="color: #3b4249"  >已取消绑定待退款-->
              <!--                <span style="color: #409EFF" @click="tuikuan(scope.row.member_id)">-->

              <!--                </span>-->
              <!--              </el-button>-->
<!--              <el-button   v-if=" scope.row.state=='3' "size="small" type="text" style="color: #3b4249" >已取消绑定</el-button>-->
<!--              <el-button   v-if=" scope.row.state=='1' "size="small" type="text" style="color: #3b4249" >待绑定</el-button>-->
<!--              <el-button   v-if=" scope.row.state=='2' "size="small" type="text" style="color: #3b4249" >已绑定</el-button>-->


            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="170">
            <template slot-scope="scope">
              {{scope.row.state==1?'待绑定':scope.row.state==2?'已绑定':scope.row.state==3?'已取消绑定':'已删除'}}
              <!--              <el-button  v-if="scope.row.state=='2' || scope.row.state=='1'" @click="ProcessingMesge(scope.row.member_id)" size="small" type="text">取消会员绑定</el-button>-->
              <!--              <el-button   v-if="scope.row.state=='3'&& scope.row.refund_state=='1' "size="small" type="text" style="color: #3b4249"  >已取消绑定待退款-->
              <!--                <span style="color: #409EFF" @click="tuikuan(scope.row.member_id)">-->

              <!--                </span>-->
              <!--              </el-button>-->
<!--              <el-button   v-if=" scope.row.state=='3' "size="small" type="text" style="color: #3b4249" >已取消绑定</el-button>-->
<!--              <el-button   v-if=" scope.row.state=='1' "size="small" type="text" style="color: #3b4249" >待绑定</el-button>-->
<!--              <el-button   v-if=" scope.row.state=='2' "size="small" type="text" style="color: #3b4249" >已绑定</el-button>-->


            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="user_id"-->
<!--            label="用户ID">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="nickname"
            label="已绑定用户">
          </el-table-column>


<!--          <el-table-column-->
<!--            label="图片">-->
<!--            <template slot-scope="scope">-->
<!--              <el-popover-->
<!--                v-if="scope.row.image_url"-->
<!--                placement="bottom"-->
<!--                trigger="hover">-->
<!--                <div style="height: 300px;overflow-y: auto">-->
<!--                  <img v-for="(i,index) in scope.row.image_url.split(',')" @click="showImg(scope.row.image_url.split(','),index)" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+i" alt="" width="300px" style="display: block">-->
<!--                </div>-->
<!--                &lt;!&ndash;<el-button slot="reference" size="small" type="text">查看图片</el-button>&ndash;&gt;-->
<!--                <img slot="reference" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+scope.row.image_url.split(',')[0]" alt="" width="60px" height="60px">-->
<!--              </el-popover>-->
<!--              <span v-if="!scope.row.image_url">无</span>-->

<!--            </template>-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--            prop="birthday"-->
<!--            label="生日">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="balance"-->
<!--            label="会员账户余额">-->
<!--          </el-table-column>-->

          <el-table-column
            label="用户注册时间">
            <template slot-scope="scope">
              {{ formatDate(scope.row.regtime )}}
            </template>
          </el-table-column>

          <el-table-column
            label="会员期限">
            <template slot-scope="scope">
              {{formatDate(scope.row.vip_exp_time) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="source"
            label="渠道">
<!--            <template slot-scope="scope">-->
<!--              {{ scope.row.vip_level=='1'?'快手':'抖音' }}-->
<!--            </template>-->
          </el-table-column>

        <el-table-column
            label="退款状态"
            width="170">
            <template slot-scope="scope">
<!--              <el-button  v-if="scope.row.state=='2' || scope.row.state=='1'" @click="ProcessingMesge(scope.row.member_id)" size="small" type="text">取消会员绑定</el-button>-->
              <el-button   v-if="scope.row.refund_state=='1' "size="small" type="text" style="color: #3b4249"  >待退款
<!--                <span style="color: #409EFF" @click="tuikuan(scope.row.member_id)">-->

<!--                </span>-->
              </el-button>
              <el-button   v-if=" scope.row.refund_state=='2' "size="small" type="text" style="color: #3b4249" >已退款</el-button>
              <el-button   v-if=" scope.row.refund_state=='3' "size="small" type="text" style="color: #3b4249" >无需退款</el-button>
<!--              <el-button   v-if=" scope.row.state=='1' "size="small" type="text" style="color: #3b4249" >待绑定</el-button>-->
<!--              <el-button   v-if=" scope.row.state=='2' "size="small" type="text" style="color: #3b4249" >已绑定</el-button>-->


            </template>
          </el-table-column>
          <el-table-column
            label="创建时间">
            <template slot-scope="scope">
              {{scope.row.create_time }}
            </template>
          </el-table-column>
              <el-table-column
            label="操作"
            width="170">
            <template slot-scope="scope">
              <el-button  v-if="scope.row.state=='2' || scope.row.state=='1'" @click="ProcessingMesge(scope.row.member_id)" size="small" type="text">取消会员绑定</el-button>
              <el-button   v-if="scope.row.state=='3'&& scope.row.refund_state=='1' "size="small" type="text" style="color: #3b4249"  > <span style="color: #409EFF" @click="tuikuan(scope.row.member_id)">退款</span></el-button>
<!--              已取消绑定待-->
              <!--              <el-button   v-if=" scope.row.refund_state=='2' "size="small" type="text" style="color: #3b4249" >已退款</el-button>-->
<!--              <el-button   v-if=" scope.row.refund_state=='3' "size="small" type="text" style="color: #3b4249" >无需退款</el-button>-->


            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-row style="margin-top: 20px">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="dataTotal">
            </el-pagination>
          </el-col>
        </el-row>
      </el-row>
    </el-row>
    <el-dialog title="新增" :visible.sync="addVisible" width="360px" :modal-append-to-body="false">
      <el-form :model="adddata" :rules="addrules" ref="adddata" style="text-align: left">

        <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
          <el-input clearable v-model="adddata.phone" auto-complete="off" placeholder="请输入" type="money_score"
                    required></el-input>
        </el-form-item>
        <el-form-item label="渠道来源" :label-width="formLabelWidth" prop="source">
          <el-input clearable v-model="adddata.source" auto-complete="off" placeholder="请输入" type="feeling_score"
                    required></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remarks">
          <el-input clearable v-model="adddata.remarks" auto-complete="off" placeholder="请输入" type="cause_score"
                    required></el-input>
        </el-form-item>
        <el-form-item label="会员类型" :label-width="formLabelWidth" prop="member_type">
          <el-select v-model="adddata.member_type" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="号码重复录入" :label-width="formLabelWidth" prop="repeat">
         <el-select v-model="adddata.repeat" placeholder="请选择">
           <el-option
             v-for="item in options"
             :key="item.value"
             :label="item.label"
             :value="item.value">
           </el-option>
         </el-select>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitadd('adddata')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="关闭会员" :visible.sync="resonVis" width="360px" :modal-append-to-body="false">

            <div style="text-align: left;line-height: 30px;font-size: 16px">取消理由：</div>
          <el-input clearable v-model="unlink_reason"  type="textarea" auto-complete="off" placeholder="请输入"
                    required></el-input>
      <div style="text-align: left;line-height: 60px;font-size: 15px">已关联会员情况下确认取消：</div>

        <el-select v-model="unlink_user" placeholder="请选择" style="text-align: left;width: 100%">
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resonVis = false">取 消</el-button>
        <el-button type="primary" @click="Processing()">确 定</el-button>
      </div>
    </el-dialog>

    <!--全屏查看图片-->
    <div style="position: fixed;width: 100%;height: 100%;top: 0;left: 0;z-index: 999" v-show="showImgValue">
      <el-carousel :interval="0" arrow="always" style="width: 100%;height: 100%" height="100%" :initial-index="showImgIndex">
        <el-carousel-item :initial-index="showImgIndex" v-for="(item,index) in showImgData" :key="index" style="width: 100%;background-color: #fff;display: flex;justify-content: center;align-items: center" @click.native="showImgValue=false">
          <img :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+item" style="max-height: 100% ">
        </el-carousel-item>
      </el-carousel>
    </div>

  </div>
</template>

<script>

  export default {
    name: "VipList",
    mounted() {
      if (!this.$store.state.login.in) {
        this.$router.push({name: "login", params: {userId: 123}})
      }
      this.getstart()
    },
    data() {
      return {
        checked: false,

        options: [{
          value: '1',
          label: '确认'
        }],
        options1: [{
          value: '1',
          label: '确认'
        }],
     options2: [{
          value: 'vip12',
          label: '12个月会员'
        },{
          value: 'vip9day',
          label: '9天会员'
        }],
        unlink_user:'',
        unlink_reason:'',
        formLabelWidth: '100px',

        resonVis:false,
        addVisible:false,
        adddata: {
          phone: '',
          source: '',
          remarks: '',
          member_type: '',

        },
        addrules: {
          phone:{required: true, message: '请输入', trigger: 'blur'},
          source: {required: true, message: '请输入', trigger: 'blur'},
          remarks: {required: true, message: '请输入', trigger: 'blur'},
          member_type: {required: true, message: '请输入', trigger: 'blur'},
        },
        tableData: [],
        pageSize: 10,
        currentPage: 1,
        dataTotal: 0,
        keyValue:'',
        showImgIndex:0,
        showImgValue:false,
        showImgData:[],
        levelValue:''
      }
    },
    methods: {
      //处理提示
      ProcessingMesge(id) {

        this.unlink_reason = ''
        this.unlink_user = ''
        this.resonVis = true
        this.member_id =id
      },
      //处理
      Processing(id,phone) {
        let thi = this
        thi.fullscreenLoading = true
        console.log(id)
        this.$http.post(global.posturl.host + global.posturl.removeMember, {
          member_id: thi.member_id,
          unlink_reason: thi.unlink_reason,
          unlink_user:thi.unlink_user
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            // thi.tuikuan(thi.member_id)
            thi.getstart()
            thi.resonVis = false
            thi.$message({
              type: 'success',
              message: response.data.msg
            });
          }else{
            thi.$message({
              type: 'error',
              message: response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error)

        });
      }, //处理
      tuikuan(id,phone) {
        let thi = this
        thi.fullscreenLoading = true
        console.log(id)
        this.$http.post(global.posturl.host + global.posturl.signRefund, {
          member_id: id,

        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
            thi.resonVis = false
            thi.$message({
              type: 'success',
              message: response.data.msg
            });
          }else{
            thi.$message({
              type: 'error',
              message: response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error)

        });
      },
      submitadd(formName) {
        let thi=this
        console.log(thi.adddata)
        thi.$refs[formName].validate((valid) => {
          if (valid) {
            thi.fullscreenLoading = true
            thi.$http.post(global.posturl.host + global.posturl.addMember,
              thi.adddata
            ).then(function (response) {
              console.log(response.data)
              var qcode = response.data.code
              var qmsg = response.data.msg
              var qdata = response.data.data
              if (qcode == 200) {
                thi.addVisible = false
                thi.fullscreenLoading = false
                thi.getstart()
                thi.$message({
                  type: 'success',
                  message: qmsg
                });
              } else {
                thi.$message({
                  type: 'warning',
                  message: qmsg
                });
                thi.fullscreenLoading = false
              }
            }).catch(function (error) {
              console.log(error)
            });

          } else {
            return false;
          }
        });
      },
      //格式化时间
      formatDate(date) {
        if (!date) {
          return ""
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "年" + (this.getMonth() + 1) + "月" + this.getDate() + "日" + this.getHours() + "点" + this.getMinutes() + "分" + this.getSeconds() + "秒";
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
      addddd(){
        let thi = this
        thi.adddata ={
          phone: '',
          source: '',
          remarks: '',
          repeat: '',
        }
        thi.addVisible = true
      },
      //绑定表格数据，分页
      getstart() {
        let thi = this
        if(thi.checked==true){
          thi.onlyMember='1'
        }
        if(thi.checked==false){
          thi.onlyMember=''
        }
        const prams = {
          page: thi.currentPage, /*当前页码*/
          pageSize: thi.pageSize, /*每页显示多少条数据*/
          key:thi.keyValue,
          state:thi.onlyMember
        }
        thi.mySelectAll('listMember',prams).then(function (value) {
          thi.tableData = value.data
          thi.dataTotal = value.Total
        })
      },
      // 全屏查看图片
      showImg(data,index){
        console.log(data)
        this.showImgIndex=index
        this.showImgValue=true
        this.showImgData=data
      },

      //选择展示数量
      handleSizeChange(val) {
        this.pageSize = val
        this.getstart()
      },
      //分页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getstart()
      },
    }
  }

</script>

<style scoped>
  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/page/user/VipList.vue